<template>
<div class="chapter">
<div class="inner_page">
<p class="toc2"><span><b>CONTENTS</b></span></p>
<p class="toc2"><a href="#/Book1/xhtml/cover">WHAT MEN DON’T TELL WOMEN</a></p>
<p class="toc1"><a href="#/Book1/xhtml/frantmatter02">What Men Don’t Tell Women</a></p>
<p class="toc1"><a href="#/Book1/xhtml/part01">Where’d You Get That Hat?</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter01">Blue Yodel 1</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter02">How to Visit the Sick</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter03">Blue Yodel 2</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter04">What Authors Do</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter05">Blue Yodel 3</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter06">The Lowdown on Southern Hospitality</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter07">Blue Yodel 4</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter08">On Hats</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter09">Blue Yodel 5</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter10">Women in the Locker Room!</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter11">Blue Yodel 6</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter12">He Took the Guilt out of the Blues</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter13">Blue Yodel 7</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter14">How to Get a Lot out of Opera</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter15">Blue Yodel 8</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter16">What to Do on New Year’s Eve — I</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter17">Blue Yodel 9</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter18">How to Sweat</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter19">Blue Yodel 10</a></p>
<p class="toc1"><a href="#/Book1/xhtml/part02">How Men Tell Time</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter20">Blue Yodel 11</a></p>
<p class="toc1"><a href="#/Book1/xhtml/chapter21">What to Do on New Year’s Eve — II</a></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter22" title="Link target outside of Sample">Blue Yodel 12</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter23" title="Link target outside of Sample">The Roosters Don’t Like It</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter24" title="Link target outside of Sample">Blue Yodel 13</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter25" title="Link target outside of Sample">Secrets of Rooting</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter26" title="Link target outside of Sample">Blue Yodel 14</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter27" title="Link target outside of Sample">Why Wayne Newton’s Is Bigger Than Yours</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter28" title="Link target outside of Sample">Blue Yodel 15</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter29" title="Link target outside of Sample">The Secret of Gatorgate</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter30" title="Link target outside of Sample">Blue Yodel 16</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter31" title="Link target outside of Sample">Still in Remedial Bayoneting</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter32" title="Link target outside of Sample">Blue Yodel 17</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter33" title="Link target outside of Sample">“I Always Plead Guilty”</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter34" title="Link target outside of Sample">Blue Yodel 18</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter35" title="Link target outside of Sample">Out of the Clauset</span></p>
<p class="toc1"><span href="#/Book1/xhtml/part03" title="Link target outside of Sample">I Didn’t Do It</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter36" title="Link target outside of Sample">Blue Yodel 19</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter37" title="Link target outside of Sample">The List of the Mohicans</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter38" title="Link target outside of Sample">Blue Yodel 20</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter39" title="Link target outside of Sample">My Cat Book Won’t Come</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter40" title="Link target outside of Sample">Blue Yodel 21</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter41" title="Link target outside of Sample">Secrets of the Apple</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter42" title="Link target outside of Sample">Blue Yodel 22</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter43" title="Link target outside of Sample">How to Sportswrite Good</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter44" title="Link target outside of Sample">Blue Yodel 23</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter45" title="Link target outside of Sample">The Truth about History</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter46" title="Link target outside of Sample">Blue Yodel 24</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter47" title="Link target outside of Sample">Why Not Active People in Beer?</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter48" title="Link target outside of Sample">Blue Yodel 25</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter49" title="Link target outside of Sample">If You Can Read This, You’re Too Close</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter50" title="Link target outside of Sample">Blue Yodel 26</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter51" title="Link target outside of Sample">Why I Live Where I Live, If I Do</span></p>
<p class="toc1"><span href="#/Book1/xhtml/chapter52" title="Link target outside of Sample">Blue Yodel 27</span></p>
<p class="toc2"><a href="#/Book2/1cover#cover">ONE FELL SOUP</a></p>
<p class="toc1"><a href="#/Book2/6chap2#chap2">On Miscellaneity; Juice-Swapping</a></p>
<p class="toc1"><a href="#/Book2/7chap3#chap3">Issues and Answers</a></p>
<p class="toc1"><a href="#/Book2/8chap4#chap4">The Singing-Impaired</a></p>
<p class="toc1"><a href="#/Book2/9chap5#chap5">Loss: A Guide to Economics</a></p>
<p class="toc1"><a href="#/Book2/10chap6#chap6">Reagan, Begin, and God</a></p>
<p class="toc1"><a href="#/Book2/11chap7#chap7">99 Percent Foundation</a></p>
<p class="toc1"><a href="#/Book2/12chap8#chap8">Eat That Wig, Wear That Sandwich</a></p>
<p class="toc1"><a href="#/Book2/13chap9#chap9">I Think It Was Little Richard</a></p>
<p class="toc1"><a href="#/Book2/14chap10#chap10">The Socks Problem</a></p>
<p class="toc1"><a href="#/Book2/15chap11#chap11">Animal and Vegetable Spirits</a></p>
<p class="toc1"><a href="#/Book2/16chap12#chap12">Chickens</a></p>
<p class="toc1"><a href="#/Book2/17chap13#chap13">Hide the Razor on April Fools’</a></p>
<p class="toc1"><a href="#/Book2/18chap14#chap14">A Near-Score of Food Songs</a></p>
<p class="toc1"><a href="#/Book2/19chap15#chap15">Corn Prone</a></p>
<p class="toc1"><a href="#/Book2/20chap16#chap16">One Pig Jumped</a></p>
<p class="toc1"><a href="#/Book2/21chap17#chap17">Used Words</a></p>
<p class="toc1"><a href="#/Book2/22chap18#chap18">Is the Pope Capitalized?</a></p>
<p class="toc1"><a href="#/Book2/23chap19#chap19">Gryll’s State</a></p>
<p class="toc1"><a href="#/Book2/24chap20#chap20">How Miss Wren Stood in de Do’</a></p>
<p class="toc1"><a href="#/Book2/25chap21#chap21">On Hearing It Averred …</a></p>
<p class="toc1"><a href="#/Book2/26chap22#chap22">More Like a Buffalo, Please</a></p>
<p class="toc1"><a href="#/Book2/27chap23#chap23">Whose Who?</a></p>
<p class="toc1"><a href="#/Book2/28chap24#chap24">Syntax’s Tack</a></p>
<p class="toc1"><a href="#/Book2/29chap25#chap25">The New Writing Aids</a></p>
<p class="toc1"><a href="#/Book2/30chap26#chap26">Total Nudes and Bubbling Babies</a></p>
<p class="toc1"><a href="#/Book2/31chap27#chap27">Light Verse</a></p>
<p class="toc1"><a href="#/Book2/32chap28#chap28">Love and Other Indelicacies</a></p>
<p class="toc1"><a href="#/Book2/33chap29#chap29">You Make Me Feel Like …</a></p>
<p class="toc1"><a href="#/Book2/34chap30#chap30">So This Is Male Sexuality</a></p>
<p class="toc1"><a href="#/Book2/35chap31#chap31">I’d Rather Have You</a></p>
<p class="toc1"><a href="#/Book2/36chap32#chap32">Don’t Be Rambunctious around Your Grandma …</a></p>
<p class="toc1"><a href="#/Book2/37chap33#chap33">The Times: No Sh*t</a></p>
<p class="toc1"><a href="#/Book2/38chap34#chap34">To Live Is to Change</a></p>
<p class="toc1"><a href="#/Book2/39chap35#chap35">The Orgasm: A Reappraisal</a></p>
<p class="toc1"><a href="#/Book2/40chap36#chap36">Valentine</a></p>
<p class="toc1"><a href="#/Book2/41chap37#chap37">The Family Jewels</a></p>
<p class="toc1"><a href="#/Book2/42chap38#chap38">Thought She Was Eve</a></p>
<p class="toc1"><a href="#/Book2/43chap39#chap39">After Pink, What?</a></p>
<p class="toc1"><a href="#/Book2/44chap40#chap40">Between Meals Song</a></p>
<p class="toc1"><a href="#/Book2/45chap41#chap41">Jealousy Song</a></p>
<p class="toc1"><a href="#/Book2/46chap42#chap42">The Wages of Fun</a></p>
<p class="toc1"><a href="#/Book2/47chap43#chap43">No Bigger than a Minute</a></p>
<p class="toc1"><a href="#/Book2/48chap44#chap44">Sports Afield</a></p>
<p class="toc1"><a href="#/Book2/49chap45#chap45">Five Ives Gets Named</a></p>
<p class="toc1"><a href="#/Book2/50chap46#chap46">Why There Will Never Be a Great Bowling Novel</a></p>
<p class="toc1"><a href="#/Book2/51chap47#chap47">Ballooning with Slick</a></p>
<p class="toc1"><a href="#/Book2/52chap48#chap48">My B.P.</a></p>
<p class="toc1"><a href="#/Book2/53chap49#chap49">Merely Shot in the Head</a></p>
<p class="toc1"><a href="#/Book2/54chap50#chap50">A Bait Box of Green Jade?</a></p>
<p class="toc1"><a href="#/Book2/55chap51#chap51">Jock Lingerie</a></p>
<p class="toc1"><a href="#/Book2/56chap52#chap52">Get Out There and Make Statements!</a></p>
<p class="toc1"><a href="#/Book2/57chap53#chap53">The Presidential Sports Profile</a></p>
<p class="toc1"><a href="#/Book2/58chap54#chap54">M.D. to The Greatest</a></p>
<p class="toc1"><a href="#/Book2/59chap55#chap55">Dedicated to Fair Hooker</a></p>
<p class="toc1"><a href="#/Book2/60chap56#chap56">Wired Into Now</a></p>
<p class="toc1"><a href="#/Book2/61chap57#chap57">Wired Into Now</a></p>
<p class="toc1"><a href="#/Book2/62chap58#chap58">The In-House Effect</a></p>
<p class="toc1"><a href="#/Book2/63chap59#chap59">The Teeth Festival</a></p>
<p class="toc1"><a href="#/Book2/64chap60#chap60">Thinking Black Holes Through</a></p>
<p class="toc1"><a href="#/Book2/65chap61#chap61">Weekly News Quiz</a></p>
<p class="toc1"><a href="#/Book2/66chap62#chap62">That Dog Isn’t Fifteen</a></p>
<p class="toc1"><a href="#/Book2/67chap63#chap63">Notes from the Edge Conference</a></p>
<p class="toc1"><a href="#/Book2/68chap64#chap64">Facing Ismism</a></p>
<p class="toc1"><a href="#/Book2/69chap65#chap65">For the Record</a></p>
<p class="toc2"><a href="#/Book3/1cover#cover">CAMELS ARE EASY, COMEDY’S HARD</a></p>
<p class="toc1"><a href="#/Book3/6chap2#chap2">How a Camel Goes</a></p>
<p class="toc1"><a href="#/Book3/7chap3#chap3">Man Chewed by Many Animals</a></p>
<p class="toc1"><a href="#/Book3/8chap4#chap4">Eating Out of House and Home</a></p>
<p class="toc1"><a href="#/Book3/9chap5#chap5">The Vanity of Human Dishes</a></p>
<p class="toc1"><a href="#/Book3/10chap6#chap6">Tan</a></p>
<p class="toc1"><a href="#/Book3/11chap7#chap7">Gilda: “This Stoff Came Outta Me?”</a></p>
<p class="toc1"><a href="#/Book3/12chap8#chap8">Nancy Is Herself</a></p>
<p class="toc1"><a href="#/Book3/13chap9#chap9">Couldn’t Use Them in a Game</a></p>
<p class="toc1"><a href="#/Book3/14chap10#chap10">What Is Funny about the National Geographic?</a></p>
<p class="toc1"><a href="#/Book3/15chap11#chap11">Caesars for the Bath Gel</a></p>
<p class="toc1"><a href="#/Book3/16chap12#chap12">Wild Fish Ripped My Flesh</a></p>
<p class="toc1"><a href="#/Book3/17chap13#chap13">I Model for GQ</a></p>
<p class="toc1"><a href="#/Book3/18chap14#chap14">Demme: A Damn Good Kennel Man</a></p>
<p class="toc1"><a href="#/Book3/19chap15#chap15">You Don’t Say “Mush”</a></p>
<p class="toc1"><a href="#/Book3/20chap16#chap16">Yo Yo Yo, Rowa uh Rowa, Hru Hru</a></p>
<p class="toc1"><a href="#/Book3/21chap17#chap17">Yet Another True Study of Mankind</a></p>
<p class="toc1"><a href="#/Book3/22chap18#chap18">On Science</a></p>
<p class="toc1"><a href="#/Book3/23chap19#chap19">Hyenas Feel Good about Themselves</a></p>
<p class="toc1"><a href="#/Book3/24chap20#chap20">How to Struggle</a></p>
<p class="toc1"><a href="#/Book3/25chap21#chap21">We Feed, We Lions</a></p>
<p class="toc1"><a href="#/Book3/26chap22#chap22">Lit Demystified Quickly</a></p>
<p class="toc1"><a href="#/Book3/27chap23#chap23">Harper’s Bazaar Asked Me to Write a Review</a></p>
<p class="toc1"><a href="#/Book3/28chap24#chap24">The Way Mama Tells It</a></p>
<p class="toc1"><a href="#/Book3/29chap25#chap25">A Man’s Got to Read</a></p>
<p class="toc1"><a href="#/Book3/30chap26#chap26">On Manhood</a></p>
<p class="toc1"><a href="#/Book3/31chap27#chap27">MEOW Dumber Than War?</a></p>
<p class="toc1"><a href="#/Book3/32chap28#chap28">Words for the Gulf</a></p>
<p class="toc1"><a href="#/Book3/33chap29#chap29">Goofing on Yahweh</a></p>
<p class="toc1"><a href="#/Book3/34chap30#chap30">The Fall</a></p>
<p class="toc1"><a href="#/Book3/35chap31#chap31">On Being One’s Own Guy</a></p>
<p class="toc1"><a href="#/Book3/36chap32#chap32">Gutes and Eulas</a></p>
<p class="toc1"><a href="#/Book3/37chap33#chap33">The Puzzle Section</a></p>
<p class="toc1"><a href="#/Book3/38chap34#chap34">New World Order: Chaos</a></p>
<p class="toc1"><a href="#/Book3/40chap35#chap35">By Christ’s Ego! (Out of Aerobic Guilt)</a></p>
<p class="toc1"><a href="#/Book3/43chap36#chap36">Are We Ready for Leaders We Can Read?</a></p>
<p class="toc1"><a href="#/Book3/45chap37#chap37">Can Credibility Be Had?</a></p>
<p class="toc1"><a href="#/Book3/48chap38#chap38">Back-to-School Double Bind</a></p>
<p class="toc1"><a href="#/Book3/51chap39#chap39">Despicability Sucks!</a></p>
<p class="toc1"><a href="#/Book3/54chap40#chap40">Our Original Mama</a></p>
<p class="toc1"><a href="#/Book3/57chap41#chap41">Declining Change</a></p>
<p class="toc1"><a href="#/Book3/60chap42#chap42">Nobody Loves Me, Everybody Hates Me, Guess I’ll Go 15 Across</a></p>
<p class="toc1"><a href="#/Book3/62chap43#chap43">Slippery Pleasures</a></p>
<p class="toc1"><a href="#/Book3/64chap44#chap44">Too Hot to Smooch?</a></p>
<p class="toc1"><a href="#/Book3/66chap45#chap45">GOP Soul Train</a></p>
<p class="toc1"><a href="#/Book3/69chap46#chap46">Clusters Gonna Get You If You Don’t Watch Out</a></p>
<p class="toc1"><a href="#/Book3/70chap47#chap47">Fly Third Class</a></p>
<p class="toc1"><a href="#/Book3/71chap48#chap48">The Sunday Paper: A Column</a></p>
<p class="toc1"><a href="#/Book3/72chap49#chap49">Three-Dot Column</a></p>
<p class="toc1"><a href="#/Book3/73chap50#chap50">In-Your-Face L-Wordism</a></p>
<p class="toc1"><a href="#/Book3/74chap51#chap51">Don’t Deficit There… DO SOMETHING</a></p>
<p class="toc1"><a href="#/Book3/75chap52#chap52">Should the South Re-Secede?</a></p>
<p class="toc1"><a href="#/Book3/76chap53#chap53">The New Solvency: We Owe It to Ourselves</a></p>
<p class="toc1"><a href="#/Book3/77chap54#chap54">Sticking It on the Gipper Sideways</a></p>
<p class="toc1"><a href="#/Book3/78chap55#chap55">Free Speech, My Foot</a></p>
<p class="toc1"><a href="#/Book3/79chap56#chap56">National Griper’s Day Is Just Like Everything Else These Days</a></p>
<p class="toc1"><a href="#/Book3/80chap57#chap57">The CEO Blues</a></p>
<p class="toc1"><a href="#/Book3/81chap58#chap58">Forgive Them, for They Have Told Us How They Did It</a></p>
<p class="toc1"><a href="#/Book3/82chap59#chap59">A Christmas Carol (for the Eighties)</a></p>
<p class="toc1"><a href="#/Book3/83chap60#chap60">Christmas Dwindles</a></p>
<p class="toc1"><a href="#/Book3/84chap61#chap61">Tomorrow Will Not Wait</a></p>
<p class="toc1"><a href="#/Book3/85chap62#chap62">And Now for the Resurrection (Blub)</a></p>
<p class="toc1"><a href="#/Book3/86chap63#chap63">Gospel Rap</a></p>
<p class="toc1"><a href="#/Book3/87chap64#chap64">Afternoon with a Buck</a></p>
<p class="toc1"><a href="#/Book3/88chap65#chap65">Good and Over</a></p>
<p class="toc2"><span href="#/Comon/endmatter01" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?17e1c800